export const stripHtmlTags = (html: string, whitelist: string[]) => {
  if (whitelist.length === 0) return html.replace(/<[^>]*>/gi, '')
  return html.replace(new RegExp(`<(?!/?(${whitelist.join('|')}))[^>]*>`, 'gi'), '')
}
